module.exports = __webpack_public_path__ + "img/page.05cef074.png";